// extracted by mini-css-extract-plugin
export default {"system":"AddUser_system__W2atH","duoBox":"AddUser_duoBox__tjeAf","boxSelect":"AddUser_boxSelect__DaLDG","label":"AddUser_label__M3Zx2","createButton":"AddUser_createButton__Qt7jQ"};